<template>
    <div class="container-fluid">
        <pickup-loading-list-modal :show.sync="showLoadingListModal" :pickup="loadingListPickup" v-if="showLoadingListModal"></pickup-loading-list-modal>
        <div class="row">
            <heading>{{ $t('pickup.menuName') }}
                <template v-slot:actions>
                    <a href="/pickup/create" class="btn btn-primary mx-1" v-if="$root.isAdmin === false">{{ $t('pickup.new') }}</a>
                </template>
            </heading>
        </div>
        <div class="row" v-if="highlightId !== null">
            <div class="col-12 text-center">
                <div class="alert alert-info d-inline-block">
                    {{ $t('pickup.filter.warningForBookingFilterApplied') }}<br/>
                    <button class="btn btn-primary mt-2" @click="resetFilters">{{ $t('pickup.actions.showAll') }}</button>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="card col-12">
                <div class="card-body">
                    <div v-if="pickups.length === 0" class="text-center">
                        <h1>{{ $t('pickup.emptyState') }}</h1>
                        <img src="/storage/empty-state.svg" height="200"/>
                    </div>
                    <div v-else>
                        <div class="row font-weight-bold border-bottom border-secondary">
                            <div class="col-1" v-if="$root.isAdmin">{{ $t('pickup.company') }}</div>
                            <div class="col-2">{{ $t('pickup.address') }}</div>
                            <div class="col-2">{{ $t('pickup.freightInfo') }}</div>
                            <div class="col-2">{{ $t('pickup.date') }}</div>
                            <div class="col-2">{{ $t('pickup.contact_info') }}</div>
                            <div  :class="{'col-2': $root.isAdmin, 'col-3': !$root.isAdmin}">{{ $t('pickup.comment') }}</div>
                            <div class="col-1"></div>
                        </div>
                        <DynamicScroller
                            :items="pickups"
                            :min-item-size="54"
                            class="row"
                            pageMode
                        >
                            <template v-slot="{ item, index, active }">
                                <DynamicScrollerItem
                                    :item="item"
                                    :active="active"
                                    :size-dependencies="[
                                      item.company.name,
                                    ]"
                                    :data-index="index"
                                    class="col-12"
                                >
                                    <pickup-index-item :pickup="item" :key="'pickup-' + item.id" @showLoadingList="showLoadingListModalFn"></pickup-index-item>
                                </DynamicScrollerItem>
                            </template>
                        </DynamicScroller>
                        <div class="text-center mt-4" v-if="pickups.length !== 0 && highlightId === null">
                            <button class="btn btn-primary" @click="loadMore">{{ $t('booking.loadMore') }}</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import PickupLoadingListModal from '@/Components/PickupLoadingListModal'
import PickupIndexItem from '@/Pages/Pickup/PickupIndexItem'
import { DynamicScroller, DynamicScrollerItem } from 'vue-virtual-scroller'
export default {
    name: 'PickupIndex',
    components: { PickupIndexItem, PickupLoadingListModal, DynamicScroller, DynamicScrollerItem },
    data: function () {
        return {
            pickups: [],
            highlightId: null,
            showLoadingListModal: false,
            loadingListPickup: null,
            nextPage: 1
        }
    },
    methods: {
        resetFilters(){
            this.highlightId = null;
            this.fetchPickups(true);
        },
        loadMore(){
            this.fetchPickups();
        },
        showLoadingListModalFn (pickup) {
            this.loadingListPickup = pickup
            this.showLoadingListModal = true
        },
        fetchPickups(reset = false){
            if(reset){
                this.nextPage = 1;
            }
            let data = {page: this.nextPage};
            if(this.highlightId){
                data = {...data, ...{only: this.highlightId}}
            }

            axios.post('/pickup/list', data).then((response) => {
                if(reset){
                    this.pickups = response.data.pickups
                }else {
                    response.data.pickups.forEach((item) => {
                        this.pickups.push(item);
                    })
                }
                this.nextPage = response.data.nextPage;
            })
        },
    },
    mounted () {
        const url = new URL(window.location);
        const params = new URLSearchParams(url.search);
        const intValue = parseInt(params.get('highlight'));
        if(!isNaN(intValue)){
            this.highlightId = intValue;
        }

        this.fetchPickups(true);
    }
}
</script>
